import React from "react";
import { useTranslation } from "react-i18next";

import {
  formatTransactionNumber,
  formatInvoiceNumber,
} from "../../helpers/format";
import { TransactionType, TransferType } from "../../types";

import styles from "./DialogHeader.module.scss";

interface Props {
  title: string;
  type: TransactionType | TransferType | "Invoice" | "InventoryAdjustment";
  number: string;
  translationRoot: string;
}

const DialogHeader = ({ type, title, number, translationRoot }: Props) => {
  const { t } = useTranslation();
  const formatNumber =
    type === "Invoice" ? formatInvoiceNumber : formatTransactionNumber;

  return (
    <div className={styles.header}>
      <div className={styles.subtitle}>
        {`${t(`${translationRoot}.type.${type}`)} ${formatNumber(number)}`}
      </div>
      <div className={styles.title}>{title}</div>
    </div>
  );
};

export default DialogHeader;
